const THREE = require('three')

require('./TransformController')(THREE)
require('./postprocessing/ShaderPass.js')(THREE)
require('./VR/VRControls.js')(THREE)
require('./VR/VREffect.js')(THREE)
require('./VR/ViveController.js')(THREE)
require('./RGBELoader')(THREE)
require('./HDRCubeTextureLoader')(THREE)
